module.exports = __webpack_public_path__ + "static/media/Cart.2ae03932.svg";